import { useSelector } from 'react-redux';
import './App.css';
import Login from './auth/Login';
import Home from './home/Home';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import NavBar from './core/Navbar';
import Storage from './storage/Storage'
import GeneralErrorDialog from './helper/general-error/GeneralErrorDialog';
import Notetaker from './notetaker/Notetaker';
import NotaEditor from './notetaker/editor/NotaEditor';
import TODOs from './todos/TODOs'
import ConfirmationModal from './helper/confirmation-modal/ConfirmationModal';
import ScriptManager from './scripts/ScriptManager';
import ScriptExecManager from './scripts/execs/ScriptExecManager';
import ScriptAgendamentoManager from './scripts/agendamento/ScriptAgendamentoManager';
import RPCDashboard from './rpc/RPCDashboard';
import GeneralDetailsDialog from './helper/general-details/GeneralDetailDialog';
import Timertracker from './timer/Timertracker'
import NotificacoesDashboard from './notificacoes/NotificacoesDashboard';
import LivrudoDashboard from './livrudo/LivrudoDashboard';
import AddLivroPage from './livrudo/AddLivroPage';
import BuscaLivrosPage from './livrudo/BuscaLivrosPage';
import DetalheLivroPage from './livrudo/DetalheLivroPage';
import AdicionarCompraLivroPage from './livrudo/AdicionarCompraLivroPage';
import AdicionarVendaLivroPage from './livrudo/AdicionarVendaLivroPage';
import Erase from './livrudo/Erase';
import CalculadoraPage from './livrudo/CalculadoraPage';
import SkuSearchPage from './livrudo/SkuSearchPage';
import DetalheSkuPage from './livrudo/DetalheSkuPage';
import AddItemCloset from './closet/AddItemCloset';
import ClosetRoomPage from './closet/ClosetRoomPage';
import VitrinePersonagensPage from './closet/VitrinePersonagensPage';
import ScrapperDash from './scrapper/ScrapperDash';
import TodasExecPage from './scripts/execs/TodasExecPage';
import LivrudoResultadosPage from './livrudo/LivrudoResultadosPage';
import WorkMainPage from './work/WorkMainPage';
import AddWorkPage from './work/AddWorkPage';

function App() {

  var authenticated = useSelector((state) => state.auth.estaAutenticado)
  var serverBasename = typeof(window.serverBasename) != "undefined" ? window.serverBasename : "";

  return (
    <BrowserRouter basename={serverBasename}>
    {authenticated && <NavBar/>}
      <GeneralErrorDialog />
      <ConfirmationModal />
      <GeneralDetailsDialog />
      {authenticated && <Timertracker />}
      <Routes>
        <Route path="/" element={
          <PrivateRoute component={() => <Home />} auth={authenticated} />
        } />
        <Route path="/storage" element={
          <PrivateRoute component={() => <Storage />} auth={authenticated} />
        } />
        <Route path="/notetaker" element={
          <PrivateRoute component={() => <Notetaker />} auth={authenticated} />
        } />
        <Route path="/todos" element={
          <PrivateRoute component={() => <TODOs />} auth={authenticated} />
        } />
        <Route path="/notetaker/editor" element={
          <PrivateRoute component={() => <NotaEditor />} auth={authenticated} />
        } />
        <Route path="/notetaker/editor/:noteId" element={
          <PrivateRoute component={() => <NotaEditor />} auth={authenticated} />
        } />
        <Route path="/scripts/execucoes" element={
          <PrivateRoute component={() => <TodasExecPage />} auth={authenticated} />
        } />
        <Route path="/scripts/lista" element={
          <PrivateRoute component={() => <ScriptManager />} auth={authenticated} />
        } />
         <Route path="/scripts/agendamentos" element={
          <PrivateRoute component={() => <ScriptAgendamentoManager />} auth={authenticated} />
        } />
        <Route path="/scripts/:scriptId" element={
          <PrivateRoute component={() => <ScriptExecManager />} auth={authenticated} />
        } />
        <Route path="/rpc" element={
          <PrivateRoute component={() => <RPCDashboard />} auth={authenticated} />
        } />
        <Route path="/notificacoes" element={
          <PrivateRoute component={() => <NotificacoesDashboard/>} auth={authenticated} />
        } />
        <Route path="/work" element={
          <PrivateRoute component={() => <WorkMainPage/>} auth={authenticated} />
        } />
        <Route path="/work/add" element={
          <PrivateRoute component={() => <AddWorkPage/>} auth={authenticated} />
        } />
        <Route path="/livrudo" element={
          <PrivateRoute component={() => <LivrudoDashboard/>} auth={authenticated} />
        } />
        <Route path="/livrudo/erase" element={
          <PrivateRoute component={() => <Erase />} auth={authenticated} />
        } />
        <Route path="/livrudo/add-livro" element={
          <PrivateRoute component={() => <AddLivroPage/>} auth={authenticated} />
        } />
        <Route path="/livrudo/livros/busca" element={
          <PrivateRoute component={() => <BuscaLivrosPage/>} auth={authenticated} />
        } />
        <Route path="/livrudo/resultados" element={
          <PrivateRoute component={() => <LivrudoResultadosPage />} auth={authenticated} />
        } />
        <Route path="/livrudo/skus/busca" element={
          <PrivateRoute component={() => <SkuSearchPage/>} auth={authenticated} />
        } />
        <Route path="/livrudo/skus/:id" element={
          <PrivateRoute component={() => <DetalheSkuPage/>} auth={authenticated} />
        } />
        <Route path="/livrudo/calculadora" element={
          <PrivateRoute component={() => <CalculadoraPage/>} auth={authenticated} />
        } />
        <Route path="/livrudo/livros/:id" element={
          <PrivateRoute component={() => <DetalheLivroPage />} auth={authenticated} />
        } />
        <Route path="/livrudo/livros/:id/add-compra" element={
          <PrivateRoute component={() => <AdicionarCompraLivroPage />} auth={authenticated} />
        } />
        <Route path="/livrudo/livros/:id/sku/:sku/vender" element={
          <PrivateRoute component={() => <AdicionarVendaLivroPage />} auth={authenticated} />
        } />
        <Route path="/closet/add-item" element={
          <PrivateRoute component={() => <AddItemCloset />} auth={authenticated} />
        } />
        <Route path="/closet/room" element={
          <PrivateRoute component={() => <ClosetRoomPage/>} auth={authenticated} />
        } />
        <Route path="/closet/personagens" element={
          <PrivateRoute component={() => <VitrinePersonagensPage />} auth={authenticated} />
        } />
        <Route path="/scrapper" element={
          <PrivateRoute component={() => <ScrapperDash />} auth={authenticated} />
        } />
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
  )
}

const PrivateRoute = ({ component: Component, auth: auth, ...rest }) => {
  if (auth) {
    return <Component {...rest} />
  } else {
    return <Navigate to={{
      pathname: '/login',
      state: { from: rest.location }
    }} />
  }

};

export default App;
